import * as React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@mui/material";
import SnackBar from "../components/SnackBarCustom";
import TableForm from "../components/TableForm";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import stock from "../assets/stock.png";
import { styles } from "../theme/styles";

function StockTienda(props) {
  const { clearMessage, message } = props;

  return (
    <>
      <Grid style={styles.content2}>
        <Typography
          variant="h5"
          color="primary"
          height={"10%"}
          style={styles.title2}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-building-store"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="#00205b"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 21l18 0" />
            <path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4" />
            <path d="M5 21l0 -10.15" />
            <path d="M19 21l0 -10.15" />
            <path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />
          </svg>
          &nbsp; Inventario en Tienda
        </Typography>
        <TableForm />
      </Grid>

      {message ? (
        <SnackBar
          message={message.text}
          variant={message.type}
          open={message ? true : false}
          onClose={clearMessage}
          time={3000}
        />
      ) : null}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    message: state.config.message,
  };
};

const creators = {
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(StockTienda);
